<template>
  <div class="d-flex flex-row">
    <div
        class="flex-row-auto offcanvas-mobile w-300px w-xl-350px"
        id="kt_profile_aside"
    >
      <div class="card card-custom card-stretch">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-end">
            <!--            <KTDropdown2></KTDropdown2>-->
          </div>
          <div class="d-flex align-items-center">
            <div
                class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
            >
              <div
                  class="symbol-label"
                  :style="{
                }"
              >
                <img :src="coreLandApi(user.image)" class="rounded" alt="" width="98" height="98">

              </div>
              <i class="symbol-badge bg-success"></i>
            </div>
            <div>
              <a
                  class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
              >{{ user.name }}</a
              >
              <div class="text-muted">{{ user.type | userType }}</div>
              <div class="mt-2">

              </div>
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-9">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">ایمیل: </span>
              <a class="text-muted text-hover-primary">{{
                  user.email
                }}</a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">اعتبار: </span>
              <span class="text-muted">{{ wallet.balance | rial }} ریال</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">شماره تلفن: </span>
              <span class="text-muted">{{ user.phone }}</span>
            </div>
          </div>
          <!--end::Contact-->
          <!--begin::Nav-->
          <div
              class="navi navi-bold navi-hover navi-active navi-link-rounded"
              role="tablist"
          >
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4 active"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="0"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Design/Layers.svg"/>
                  </span>
                </span>
                <span class="navi-text font-size-lg">نمای کلی</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="1"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/General/User.svg"/>
                  </span>
                </span>
                <span class="navi-text font-size-lg">اطلاعات شخصی</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="4"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg
                        src="media/svg/icons/Communication/Mail-opened.svg"
                    />
                  </span>
                </span>
                <span class="navi-text font-size-lg">تکمیل پروفایل</span>
              </a>
            </div>

            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="2"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Code/Compiling.svg"/>
                  </span>
                </span>
                <span class="navi-text font-size-lg">اطلاعات حساب</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="3"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg
                        src="media/svg/icons/Communication/Shield-user.svg"
                    />
                  </span>
                </span>
                <span class="navi-text font-size-lg">تغییر گذرواژه</span>
                <span class="navi-label">
                  <span
                      class="label label-light-danger label-rounded font-weight-bold"
                  >5</span
                  >
                </span>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!--begin::Content-->
    <div class="flex-row-fluid ml-lg-8">
      <b-tabs class="hide-tabs" v-model="tabIndex">
        <b-tab active>
          <!--          <KTProfileOverview></KTProfileOverview>-->
        </b-tab>

        <b-tab active>
          <KTPersonalInformation></KTPersonalInformation>
        </b-tab>

        <b-tab>
          <KTAccountInformation></KTAccountInformation>
        </b-tab>

        <b-tab>
          <KTChangePassword></KTChangePassword>
        </b-tab>

        <b-tab>
          <KTEmailSettings></KTEmailSettings>
        </b-tab>
      </b-tabs>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import KTDropdown2 from "@/view/content/dropdown/Dropdown2";
import KTProfileOverview from "@/view/pages/profile/profile-comp-1/ProfileOverview";
import KTPersonalInformation from "@/view/pages/profile/profile-comp/PersonalInformation";
import KTAccountInformation from "@/view/pages/profile/profile-comp/AccountInformation";
import KTChangePassword from "@/view/pages/profile/profile-comp/ChangePassword";
import KTEmailSettings from "@/view/pages/profile/profile-comp/EmailSettings";

export default {
  name: "custom-page",
  components: {
    KTDropdown2,
    KTProfileOverview,
    KTPersonalInformation,
    KTAccountInformation,
    KTChangePassword,
    KTEmailSettings
  },
  data() {
    return {
      tabIndex: 0,
      wallet: {}

    };
  },
  mounted() {
    this.wallet = this.getWallet();
    // this.currentUserPersonalInfo.photo = this.coreLandApi(this.user.image)
    // let div = document.querySelector('div[class="symbol-label"]')
    // div.style.backgroundImage = "url('https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Palacio_CEC%2C_Bucarest%2C_Ruman%C3%ADa%2C_2016-05-29%2C_DD_91-93_HDR.jpg/536px-Palacio_CEC%2C_Bucarest%2C_Ruman%C3%ADa%2C_2016-05-29%2C_DD_91-93_HDR.jpg')"

    this.$store.dispatch(SET_BREADCRUMB, [{title: this.name}]);
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),

    getFullName() {
      return (
          this.currentUserPersonalInfo.name +
          " " +
          this.currentUserPersonalInfo.surname
      );
    }
  }
};
</script>
